import { getSuggestionAtIndex } from 'owa-mail-search-store';
import { SuggestionKind } from 'owa-search-service';
/**
 * Returns the display text for the suggestion at the given index.
 * @param index The target suggestion's index
 * @returns The display text of the target suggestion
 */
export default function getSuggestionText(index) {
    // If no suggestion exists at given index, return an empty string.
    var suggestion = getSuggestionAtIndex(index);
    if (!suggestion) {
        return '';
    }
    switch (suggestion.kind) {
        case SuggestionKind.Category:
            return suggestion.Name;
        case SuggestionKind.Files:
            return suggestion.Name;
        case SuggestionKind.Keywords:
            if (suggestion.Segments) {
                return suggestion.Segments.map(function (e) { return (e.Type == 'Person' ? e.DisplayName : e.Type == 'Text' ? e.Text : ''); }).join(' ');
            }
            else {
                return suggestion.QueryText;
            }
        case SuggestionKind.People:
            return suggestion.DisplayName;
        default:
            return '';
    }
}
//# sourceMappingURL=getSuggestionText.js.map